import { ajax } from '../../../services/helper'
class ApiService {

    getAssetVendorsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/vendors/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getAssetVendorById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/vendors/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getAssetVendorGroupsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brandGroups/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getPlatformsComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
    


    addAssetVendor = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/vendors/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editAssetVendor = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/vendors/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Asset Vendors/services/apiservices.js